import { render, staticRenderFns } from "./AddTournamentTeamCard.vue?vue&type=template&id=3e9ff57f&scoped=true"
import script from "./AddTournamentTeamCard.vue?vue&type=script&lang=js"
export * from "./AddTournamentTeamCard.vue?vue&type=script&lang=js"
import style0 from "./AddTournamentTeamCard.vue?vue&type=style&index=0&id=3e9ff57f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9ff57f",
  null
  
)

export default component.exports